module.exports = __webpack_public_path__ + "media/assets/images/down-caret-d578b1c535461f12d625906f8a385709.svg";